import React, { Component } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import TextField from "@mui/material/TextField";
import { Calendar } from "primereact/calendar";
import { mappingRptActions } from "../../actions";
import { connect } from "react-redux";
import tableRequest from "../../models/tableRequest.js";
import { Toast } from "primereact/toast";
import { CSVLink } from "react-csv";
import { format } from 'date-fns'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Select, MenuItem, InputLabel, FormControl } from '@mui/material';
class MappingRpt extends Component {
  constructor(props) {
    super(props);
    this.tblResponse = new tableRequest();
    this.onPage = this.onPage.bind(this);
    this.onSort = this.onSort.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.FilterData = this.FilterData.bind(this);
    this.searchFilter = this.searchFilter.bind(this);
    this.Export = this.Export.bind(this);
    this.state = {
      loading: false,
      FromDate: new Date(),
      ToDate: new Date(),
      first: 0,
      rows: 5,
      PageNo: 0,
      totalRecords: 0,
      globalFilter: null,
      visible: false,
      sortOrder: "",
      datalist: [],
      salesPersons: [],
      selectedSalesPerson: "",
    };
  }
  componentDidMount() {
    var date = new Date();
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() - 7);
    this.tblResponse.FromDate = date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    });
    this.tblResponse.ToDate = new Date().toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    });
    // this.tblResponse.FromDate=this.getCurrentDateYYYYMMDD(date);
    // this.tblResponse.ToDate=this.getCurrentDateYYYYMMDD(date);
    this.setState({
      FromDate: date,
      ToDate: new Date()
    });
    this.props.fetchApi(this.tblResponse);
    this.props.exportingData(this.tblResponse);
    this.props.SalesPerson(this.tblResponse);
  }
 
isRowNotEmpty(row) {
  
  if (!row || typeof row !== 'object') return false;
  
  return Object.values(row).some(val => {
    if (val === null || val === undefined) return false;
    
    // Handle numbers (including 0)
    if (typeof val === 'number') return true;
    
    // Handle booleans
    if (typeof val === 'boolean') return true;
    
    // Handle dates
    if (val instanceof Date) return true;
    
    // Handle strings (check for non-whitespace content)
    if (typeof val === 'string') return val.trim() !== '';
    
    // Handle objects/arrays (check if they have any content)
    if (typeof val === 'object') {
      return Object.keys(val).length > 0;
    }
    
    return true;
  });
}

  componentDidUpdate(prevProps) {
    if (prevProps.mappingList !== this.props.mappingList) {
      // this.props.myProp has a different value
      if (this.props.mappingList) {
        var e = this.props.mappingList;
        this.setState({
          totalRecords: e[0].TotalRows
        });
      }
      //const filteredData = this.props.mappingList.filter(row => row.Month !== null && row.Day !== null);
      //console.log("filter",filteredData)

    }
 
    //   if (prevProps.salesPersonList !== this.props.salesPersonList && this.props.salesPersonList) {
    //   this.setState({
    //     salesPersons: this.props.salesPersonList
    //   });
    // }
 
    if (
      prevProps.salesPersonList !== this.props.salesPersonList &&
      this.props.salesPersonList.length > 0 &&
      !this.state.selectedSalesPerson
    ) {
      const defaultSalesPerson = this.props.salesPersonList[0];
      this.setState({ selectedSalesPerson: defaultSalesPerson.value });
      this.tblResponse.SalespersonId = defaultSalesPerson.value;
      this.props.fetchApi(this.tblResponse);
    }
 
  }
  GetMapping() {
    let ToDt = new Date();
    let FrmDt = new Date();
    FrmDt.setDate(ToDt.getDate() - 7);
 
    const myFmDt = this.getCurrentDateYYYYMMDD(FrmDt);
    const myToDt = this.getCurrentDateYYYYMMDD(ToDt);
 
    this.tblResponse.FromDate = myFmDt;
    this.tblResponse.ToDate = myToDt;
    this.props.fetchApi(this.tblResponse);
  }
 
  FilterData() {
    this.tblResponse.FromDate = this.getCurrentDateYYYYMMDD(this.state.FromDate);
    this.tblResponse.ToDate = this.getCurrentDateYYYYMMDD(this.state.ToDate);
 
    this.props.fetchApi(this.tblResponse);
  }
  getCurrentDateYYYYMMDD(dt) {
    var dd = String(dt.getDate()).padStart(2, "0");
    var mm = String(dt.getMonth() + 1).padStart(2, "0");
    var yyyy = dt.getFullYear();
 
    dt = yyyy + "/" + mm + "/" + dd;
    return dt;
  }
  Export() {
    this.tblResponse.PageSize = -1;
    this.tblResponse.First = 1;
    this.tblResponse.IsActive = true;
    this.tblResponse.SearchValue =
      this.state.globalFilter == null ? "" : this.state.globalFilter;
    this.tblResponse.SortColumn = "CreatedDt";
    this.tblResponse.DealerId = this.state.UserId;
    this.tblResponse.SortOrder = "DESC";
    this.tblResponse.FromDate = this.state.FromDate.toLocaleDateString(
      "en-US",
      {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      }
    );
    this.tblResponse.ToDate = this.state.ToDate.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    });
    this.props.exportingData(this.tblResponse);
    this.setState({
      Download: true
    });
  }
  handleChange(event) {
    const { name, value } = event.target;
    switch (name) {
      case "FromDate":        
        if (value === null || !(value instanceof Date)) {
          this.formIsValid = false;
          toast.error("Please select from date")
          return;
        } else if (
          !value
            .toLocaleDateString("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit"
            })
            .match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/)
        ) {
          this.formIsValid = false;
          toast.error("Please enter only date")
          return;
        } else if (value instanceof Date && this.state.ToDate instanceof Date) {
          const startDate = value;
          const endDate = this.state.ToDate;
          if (!(Date.parse(startDate) <= Date.parse(endDate))) {
            this.formIsValid = false;
            toast.error("From date must be less than to date")
            return;
          }
        }
        break;
      case "ToDate":
        if (value === null || !(value instanceof Date)) {
          this.formIsValid = false;
          toast.error("Please select to date")
          return;
        } else if (
          !value
            .toLocaleDateString("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit"
            })
            .match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/)
        ) {
          this.formIsValid = false;
          toast.error("Please enter only date")
          return;
        } else if (
          value instanceof Date &&
          this.state.FromDate instanceof Date
        ) {
          const startDate = this.state.FromDate;
          const endDate = value;
          if (!(Date.parse(startDate) <= Date.parse(endDate))) {
            this.formIsValid = false;
            toast.error("To date must be greater than from date")
            return;
          }
        }
        break;
      default:
        break;
    }
    this.setState({ [name]: value });
  }
  //to lazy load
  getLazyLoadingValues(event) {
    this.setState({ rows: event.rows, first: event.first });
    this.tblResponse.PageSize = event.rows;
    this.tblResponse.First = event.first + 1;
    this.tblResponse.IsActive = true;
    //this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
    let searchValue = "";
    if (event.globalFilter) {
    searchValue = event.globalFilter;
    } else if (event.filters) {
    const filterValues = Object.values(event.filters)
      .map(f => f?.value)
      .filter(v => v); 
    searchValue = filterValues.join(" ");
  }
    this.tblResponse.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    this.tblResponse.FromDate = this.getCurrentDateYYYYMMDD(this.state.FromDate);
    this.tblResponse.ToDate = this.getCurrentDateYYYYMMDD(this.state.ToDate);
  }  
  onPage(event) {
    this.tblResponse.PageSize = event.rows;
    this.props.loadingData(true);
    //imitate delay of a backend call
    setTimeout(() => {
      debugger
      this.getLazyLoadingValues(event);
      this.props.fetchApi(this.tblResponse);
    }, 250);
  }
  //to search
  searchFilter(e) {
    this.tblResponse.SearchValue = e.target.value;
    this.props.fetchApi(this.tblResponse);
  }
  //to sort
  onSort(event) {
    this.props.loadingData(true);
    this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1 });
    const sortField =
      event.multiSortMeta[0].field === "CreatedDate"
        ? "CreatedDate"
        : event.multiSortMeta[0].field;
    this.tblResponse.SortColumn = sortField ? sortField : "";
    this.tblResponse.SortOrder = this.state.sortOrder === 1 ? "DESC" : "ASC"; //this.state.sortOrder === 1 ? 'DESC' : 'ASC';
    this.props.fetchApi(this.tblResponse); 
  }
  getSalespersonName(salespersonId) {
    const person = this.props.salesPersonList.find(p => p.value === salespersonId);
     return person ? person.label.replace(/\s+/g, '_') : 'All';
  }
  
  render() {
    return (
      <div className="datatable-filter-demo">
        <Toast ref={(el) => (this.toast = el)} />
        <div className="row mb-3">
          <div className="col-md-2 report">
            <h4>DVR Report</h4>
          </div>
          <div className="col-md-10">
            <div className="row text-right">
              <div className="col-md-2">
                <FormControl fullWidth size="small" variant="outlined" className="fullwidth">
                  <InputLabel id="salesperson-label">Sales Person</InputLabel>
                  <Select
                    labelId="salesperson-label"
                    id="salesperson-select"
                    value={this.state.selectedSalesPerson}
                    //value={this.props.mappingList}
                    name="selectedSalesPerson"
                    onChange={(e) => {
                      //debugger
                      const selected = e.target.value;
                      this.setState({ selectedSalesPerson: selected });
                      this.tblResponse.SalespersonId = selected;
                      this.props.fetchApi(this.tblResponse);
                    }}
                  // onChange={this.handleChange}
                  //   label="Sales Person"
                  >
                    {/* <MenuItem value=""><em>All</em></MenuItem> */}
                    {this.props.salesPersonList.map((person, index) => (
                      <MenuItem key={index} value={person.value}>
                        {person.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
 
              </div>
              <div className="col-md-2">
                <Calendar
                  placeholder="From Date"
                  name="FromDate"
                  showIcon="true"
                  value={this.state.FromDate}
                  onChange={this.handleChange}
                ></Calendar>
              </div>
              <div className="col-md-2">
                <Calendar
                  placeholder="To Date"
                  name="ToDate"
                  showIcon="true"
                  value={this.state.ToDate}
                  onChange={this.handleChange}
                ></Calendar>
              </div>
              <div className="col-md-2 text-center ">
                <button
                  type="button"
                  onClick={this.FilterData}
                  className="btn btn-primary p-2 pl-2 pr-2 buttone"
                >
                  Submit
                </button>
                &nbsp;
                {/* <CSVLink
                  //data={this.props.List}
                   data={exportData}
                  headers={this.state.headers}
                  filename={"DVR report.csv"}
                  target="_blank"
                > */}<CSVLink
                  //data={this.props.List}
                  data={
                    this.props.List
                      ? this.props.List.map(({ TotalRows, ...rest }) => rest)
                      : []
                  }
                  //data={exportData}
                  headers={this.state.headers}
                  // filename={`${this.state.selectedSalesPerson|| 'All'}_${this.getCurrentDateYYYYMMDD(this.state.FromDate)}_to_${this.getCurrentDateYYYYMMDD(this.state.ToDate)}.csv`}
                  // target="_blank"
                  filename={`${this.getSalespersonName(this.state.selectedSalesPerson)}_${this.getCurrentDateYYYYMMDD(this.state.FromDate)}_To_${this.getCurrentDateYYYYMMDD(this.state.ToDate)}.csv`}
                  target="_blank"
                >
 
                  <button
                    onClick={this.Export}
                    className="btn btn-success p-2 pr-2 pl-2 buttone">
                    Export
                  </button>
                </CSVLink>
              </div>
              <div className="col-md-2">
                <TextField
                  id="standard-basic"
                  size="small"
                  variant="outlined"
                  className="fullwidth"
                  label="Search"
                  onInput={this.searchFilter}
                />
              </div>
              {/*  */}
            </div>
          </div>
        </div>
        <div className="card">
          <DataTable
            // value={(this.props.mappingList || []).filter(row => row.Month !== null && row.Day !== null && row.ActivityDate !==null && 
            //   typeof row.SalesPersonName === 'string' &&
            //   row.SalesPersonName.trim() !== '' && row.state !==null)}
            value={(this.props.mappingList || [] ).filter(
              row => row.Remarks
            )}
            //totalRecords={(this.state.mappingList || []).filter(row => row.Month !== null && row.Day !== null).length}
           // Value={(this.props.mappingList)}
            scrollable
            responsive={true}
            globalFilter={this.state.globalFilter}
            emptyMessage="No Data found."
            sortMode="multiple"
            paginator={true}
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={this.state.rows}
            style={{ width: "100%" }}
            rowsPerPageOptions={[5, 10, 30, 100]}
            totalRecords={this.state.totalRecords }
            lazy={true}
            first={this.state.first}
            onPage={this.onPage}
            onSort={this.onSort}
            loading={this.props.loading}
            ref={(el) => {
              this.dt = el;
            }}
          >  
            <Column
              style={{ width: "10%" }}
              field="SalesPersonName"
              disabled
              header="SalesPerson Name"
              sortable
            ></Column>
            <Column
              style={{ width: "10%" }}
              field="RegionName"
              disabled
              header="Region Name"
              sortable
            ></Column>
            {/* <Column
              style={{ width: "15%" }}
              field="ToNo"
              disabled
              header="To No"
              sortable
            ></Column>
            <Column
              style={{ width: "15%" }}
              field="Qty"
              disabled
              header="Qty"
              sortable
            ></Column>
            <Column
              style={{ width: "15%" }}
              field="BatchNo"
              disabled
              header="Batch No"
              sortable
            ></Column> */}
            {/* <Column field="Location" header="Location" sortable></Column> */}
            {/* <Column field="BatchNo" disabled header="Batch No" sortable></Column> */}
            <Column
              style={{ width: "10%" }}
              field="State"
              header="State"
              sortable
            ></Column>
            <Column
              style={{ width: "10%" }}
              field="District"
              header="District"
              sortable
            ></Column>
            <Column
              style={{ width: "10%" }}
              field="CityTownName"
              header="CityTown Name"
              sortable
            ></Column>
            <Column
              style={{ width: "10%" }}
              field="CounterName"
              header="Counter Name"
              sortable
            ></Column>
            <Column
              style={{ width: "10%" }}
              field="BusinessPotentialMonthly"
             //header="BusinessPotential Monthly"
              header="Business Potential Monthly (Cr)"
              sortable
            ></Column>
            <Column
              style={{ width: "10%" }}
              field="YearlyBusinessPotential"
            //header="YearlyBusiness Potential"
              header="Yearly Business Potential (Cr)"
             sortable
            ></Column>
            <Column
              style={{ width: "10%" }}
              field="OrderPassedTo"
              header="Order Passed To"
              sortable
            ></Column>
            <Column
              style={{ width: "10%" }}
              field="Remarks"
              header="Remarks"
            >
            </Column>
            <Column
              style={{ width: "10%" }}
              field="ActivityDate"
              header="Visited Date"
              body={(rowData) => {
              const originalDate = new Date(rowData.ActivityDate);
              const updatedDate = new Date(originalDate);
               updatedDate.setDate(updatedDate.getDate() + 1); 
               return format(updatedDate, 'yyyy-MM-dd'); 
              }}
              sortable
            ></Column>
            {/* <Column field="Remark" header="Remark" sortable></Column> */}
          </DataTable>
        </div>
      </div>
    );
  }
} 
const mapStateToProps = (state) => {
  //console.log("Data", state)
  return {
    mappingList: state.mappingRpt.items,
    List:
      state.mappingRpt.exportitems == undefined
        ? []
        : state.mappingRpt.exportitems,
    loading: state.verification.loding,
    IsDownload: state.verification.isDownload,
    salesPersonList: state.mappingRpt.issueData || []
  };
}; 
const mapDispatchToProps = (dispatch) => {
  return {
    fetchApi: (obj) => {
      dispatch(mappingRptActions.getAll(obj));
    },
    SalesPerson: (obj) => {
      dispatch(mappingRptActions.fetchSalesPerson(obj));
    },
    loadingData: (isLoding) =>
      dispatch(mappingRptActions.loadingData(isLoding)),
    exportingData: (obj) => dispatch(mappingRptActions.exportData(obj))
  };
}; 
export default connect(mapStateToProps, mapDispatchToProps)(MappingRpt);